import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useCallback, useState, useEffect } from 'react'
import { BUTTON_HTML_TYPE } from 'constants/button'
import style from './style.scss'

/**
 *
 * @param {string} params0.value the selected option value
 * @param {array} params0.options toggle view's option list
 * @param {function} params0.onChange will be trigger with clicked option's value when option item was click `(value: string) => void`
 * @param {bool} params0.disabled to make component not clickable. (default: false)
 */
const ToggleView = (props) => {
  const { value, onChange, options, disabled } = props
  const [selectedValue, setSelectedValue] = useState(value)

  const handleClick = useCallback(
    (optionValue) => () => {
      setSelectedValue(optionValue)
    },
    [],
  )

  useEffect(() => {
    if (onChange && value !== selectedValue) {
      onChange(selectedValue)
    }
  }, [onChange, selectedValue, value])

  return (
    <div className="toggle-view__wrapper">
      <style jsx>{style}</style>
      {options?.map(({ value: optionValue, component }, index) => (
        <button
          type={BUTTON_HTML_TYPE.default}
          key={`toggle-view-${optionValue}`}
          className={clsx('toggle-view__button', {
            left: index === 0,
            right: index === options.length - 1,
            active: optionValue === selectedValue,
          })}
          disabled={disabled}
          onClick={handleClick(optionValue)}
          data-cy={`toggle-option-${index}`}
        >
          {component}
        </button>
      ))}
    </div>
  )
}

ToggleView.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.element,
      value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.bool,
      ]),
    }),
  ).isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

ToggleView.defaultProps = {
  onChange: undefined,
  disabled: false,
}

export default ToggleView
